var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrentLoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M482,270c0,75.901-35.099,143.101-90,187.2l-151-68.399L211,375l-30-270l-0.601-66.899   C199.6,32.999,220,30,241,30C373.599,30,482,137.401,482,270z",
    fill: "#64e1dc",
    "data-original": "#64e1dc",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M482,270c0,75.901-35.099,143.101-90,187.2l-151-68.399V30C373.599,30,482,137.401,482,270z",
    fill: "#a8d3d8",
    "data-original": "#a8d3d8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M198.404,324.63L121,183.296L3.508,230.592C1.381,243.442,0,256.547,0,270   c0,93.933,55.089,176.04,133.706,215.455l88.954-58.057L198.404,324.63z",
    fill: "#e0f4ff",
    "data-original": "#e0f4ff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M392,0c-66.301,0-120,53.699-120,120c0,23.101,6.599,45.3,18.9,64.501l88.5,138.6    c2.699,4.199,7.5,6.899,12.599,6.899s9.901-2.701,12.599-6.899l88.5-138.6c12.301-19.2,18.9-41.4,18.9-64.501    C512,53.699,458.301,0,392,0z M392,180c-32.999,0-60-27.001-60-60s27.001-60,60-60s60,27.001,60,60S424.999,180,392,180z",
    fill: "#ff641a",
    "data-original": "#ff641a",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M512,120c0,23.101-6.599,45.3-18.9,64.501l-88.5,138.6c-2.699,4.199-7.5,6.899-12.599,6.899V180   c32.999,0,60-27.001,60-60s-27.001-60-60-60V0C458.301,0,512,53.699,512,120z",
    fill: "#cd0000",
    "data-original": "#cd0000"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M392,375v82.2c-9.3,7.5-19.501,15.399-30,21.4C326.6,498.999,284.801,512,241,512   c-27.9,0-54.6-6.099-79.501-14.801c-9.598-3.3-18.9-7.2-27.9-11.699l18.301-55.3c1.199-3.602,3.898-6.901,7.5-8.701l48.3-24   l-24.3-72.9l-85.801-57.001C93.401,264.6,91,260.099,91,255v-41.7L3.6,230.7c1.8-11.1,3.9-21.899,7.2-32.1   c21.301-67.8,72.7-122.699,137.5-150c10.201-4.2,21-7.8,32.1-10.499l56.1,56.4C239.5,97.2,241,101.1,241,105v60   c0,2.401-0.601,4.501-1.5,6.599L211,228.6v77.1l48.6,24.3H317c2.401,0,4.501,0.601,6.599,1.5l60,30C388.7,364.2,392,369.3,392,375z   ",
    fill: "#64e1dc",
    "data-original": "#64e1dc",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M392,375v82.2c-9.3,7.5-19.501,15.399-30,21.4C326.6,498.999,284.801,512,241,512V320.7l18.6,9.3   H317c2.401,0,4.501,0.601,6.599,1.5l60,30C388.7,364.2,392,369.3,392,375z",
    fill: "#00c8c8",
    "data-original": "#00c8c8",
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLoc);
export default __webpack_public_path__ + "static/media/currentLoc.06099e66bd6e0c40482b7600273a85a4.svg";
export { ForwardRef as ReactComponent };